// frontend/src/config/serviceCatalog.js
// Single source of truth for all supported integration services.
// To add a new service in the future, just add an entry here — no other changes needed.

export const SERVICE_CATALOG = [
    {
        id: 'sendgrid',
        label: 'SendGrid',
        icon: 'Mail',
        description: 'Transactional email delivery',
        color: '#1a82e2',
        category: 'Email',
        fields: [
            { key: 'api_key', label: 'API Key', type: 'password', required: true },
            { key: 'from_email', label: 'From Email', type: 'email', required: true },
            { key: 'from_name', label: 'From Name', type: 'text', required: false },
        ],
    },
    {
        id: 'smtp',
        label: 'SMTP',
        icon: 'Server',
        description: 'Custom SMTP server (Office365, Gmail, etc.)',
        color: '#6366f1',
        category: 'Email',
        fields: [
            { key: 'host', label: 'SMTP Host', type: 'text', required: true },
            { key: 'port', label: 'Port', type: 'number', required: true },
            { key: 'username', label: 'Username', type: 'text', required: false },
            { key: 'password', label: 'Password', type: 'password', required: false },
            { key: 'from_email', label: 'From Email', type: 'email', required: false },
        ],
    },
    {
        id: 'twilio',
        label: 'Twilio',
        icon: 'Phone',
        description: 'SMS & WhatsApp notifications',
        color: '#f22f46',
        category: 'SMS',
        fields: [
            { key: 'account_sid', label: 'Account SID', type: 'text', required: true },
            { key: 'auth_token', label: 'Auth Token', type: 'password', required: true },
            { key: 'from_number', label: 'From Number', type: 'text', required: true },
        ],
    },
    {
        id: 'openai',
        label: 'OpenAI',
        icon: 'Zap',
        description: 'AI completions & embeddings',
        color: '#10a37f',
        category: 'LLM',
        fields: [
            { key: 'api_key', label: 'API Key', type: 'password', required: true },
            { key: 'org_id', label: 'Org ID (optional)', type: 'text', required: false },
        ],
    },
    {
        id: 'sharepoint',
        label: 'SharePoint',
        icon: 'FolderOpen',
        description: 'Microsoft SharePoint Online (via Azure AD app)',
        color: '#0078d4',
        category: 'Collaboration',
        fields: [
            { key: 'tenant_id',     label: 'Azure Tenant ID',   type: 'text',     required: true },
            { key: 'client_id',     label: 'App Client ID',     type: 'text',     required: true },
            { key: 'client_secret', label: 'App Client Secret', type: 'password', required: true },
            { key: 'site_url',      label: 'Default Site URL',  type: 'text',     required: false },
        ],
    },
    // ─── Add new services below this line ───────────────────────────────────
    // Example:
    // {
    //     id: 'stripe',
    //     label: 'Stripe',
    //     icon: 'CreditCard',
    //     description: 'Payment processing',
    //     color: '#635BFF',
    //     category: 'Payments',
    //     fields: [
    //         { key: 'secret_key',      label: 'Secret Key',      type: 'password', required: true },
    //         { key: 'publishable_key', label: 'Publishable Key', type: 'text',     required: false },
    //     ],
    // },
];

export const getServiceMeta = (id) =>
    SERVICE_CATALOG.find((s) => s.id === id) || { label: id, icon: 'Plug', color: '#888', fields: [] };
